import { Box, Button, Card, TextField } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React from "react";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { IModuleAction } from "../../../shared/interfaces/module/IModule";

interface IProps {
  control: Control<IModuleAction>;
  isUpdate?: boolean;
}
const ModuleForm = ({ control, isUpdate }: IProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Card>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name={"name"}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                disabled
                error={!!error?.message}
                helperText={error?.message ? t(error?.message) : ""}
                value={value ?? ""}
                onChange={onChange}
                label={t("module.name")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12, lg: 6 }}>
          <Controller
            name="price"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                error={!!error?.message}
                helperText={
                  error?.message ? t(error?.message, { minLength: 0 }) : ""
                }
                value={value ?? ""}
                onChange={onChange}
                type={"number"}
                label={t("general.price")}
                sx={{ width: "100%" }}
              />
            )}
          />
        </Grid>

        <Grid size={{ xs: 12 }}>
          <Controller
            name="description"
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <TextField
                label={t("general.description")}
                value={value ?? ""}
                onChange={onChange}
                error={!!error?.message}
                helperText={t(error?.message as string)}
                multiline
                minRows={3}
                fullWidth
              />
            )}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant={"contained"}
          color={"secondary"}
          sx={{ marginTop: "20px" }}
          type={"button"}
          onClick={() => navigate(-1)}
        >
          {t("button.cancel")}
        </Button>
        <Button
          variant={"contained"}
          sx={{ margin: "20px 0 0 10px" }}
          type={"submit"}
        >
          {t(isUpdate ? "button.update" : "button.create")}
        </Button>
      </Box>
    </Card>
  );
};

export default ModuleForm;
